function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, tempo, Image, mapResponsive } from '@tempo/core';
import { LandingDescription } from './LandingDescription';
import { useLandingPageScales } from './LandingPage';
import { LandingSection } from './LandingSection';
export const LandingHeroImageContainer = tempo(Flex, {
    baseStyle: {
        flex: 1,
        position: 'absolute',
        h: '100%',
        w: '100%'
    }
});
export const LandingHero = (_param)=>{
    var { bgImg, children, minH = {
        base: '250px',
        md: '400px'
    }, textAlign = 'center' } = _param, gridProps = _object_without_properties(_param, [
        "bgImg",
        "children",
        "minH",
        "textAlign"
    ]);
    const { containerGutters: px } = useLandingPageScales();
    const alignItems = mapResponsive(textAlign, (val)=>{
        if (val) {
            if (val === 'center') {
                return val;
            }
            if (val === 'left' || val === 'start') {
                return 'flex-start';
            }
            if (val === 'right' || val === 'end') {
                return 'flex-end';
            }
        }
        return val;
    });
    return /*#__PURE__*/ _jsxs(LandingSection, _object_spread_props(_object_spread({
        position: "relative",
        minH: minH
    }, gridProps), {
        children: [
            bgImg && /*#__PURE__*/ _jsx(LandingHeroImageContainer, {
                children: bgImg
            }),
            /*#__PURE__*/ _jsx(LandingDescription, {
                px: px,
                alignItems: alignItems,
                textAlign: textAlign,
                zIndex: "1",
                children: children
            })
        ]
    }));
};
export const LandingHeroImage = tempo(Image, {
    baseStyle: {
        w: '100%',
        objectFit: 'cover'
    }
});

//# sourceMappingURL=LandingHero.js.map